import { ProductColorOptionValues } from './ProductColorOptionValues';
import { ProductOptionValues } from './ProductOptionValues';
import { ProductGroupOptions } from './ProductGroupOptions';

export function ProductOptions({
  enabledsizeGuide,
  product,
  selectedOptions,
  setSelectedOptions,
  inventory,
  inventoryFetched,
  sizeGuides,
  swatches,
  disableGroupHistory,
  enabledSoldOutColorSwatch, 
  isSoldOut, 
  soldOutQty,
  enabledGroupTabs,
  enabledGroupTabsLink,
  productTypeForGroupTabs,
  enabledGroupOptions,
  enabledGroupOptionsLink,
  productTypeForGroupOptions,
  needsSelection,
  optionChanges,
  setOptionChanges,
  groupedBreadcrumbs,
}) {

  const moreThanTwoOptions = product?.options?.length >= 3;

  const thirdOptionKey = Object.keys(product?.optionsMap)[2];
  const thirdOptionValue = thirdOptionKey ? product?.optionsMap[thirdOptionKey] : null;
  const optionsCount = thirdOptionValue ? (Array.isArray(thirdOptionValue) ? thirdOptionValue.length : Object.keys(thirdOptionValue).length) : 0;

  const variantsWithAvailableForSaleFalse = inventory?.variants ? Object.values(inventory.variants).filter(variant => !variant.availableForSale) : [];
  const unavailableProductVariants = product?.variants.filter(variant =>
    variantsWithAvailableForSaleFalse.some(unavailableVariant => unavailableVariant.id === variant.id)
  );
  const secondPropertyValues = unavailableProductVariants.map(variant => {
    const keys = Object.keys(variant.selectedOptionsMap);
    const secondKey = keys[1];
    return variant.selectedOptionsMap[secondKey];
  });
  const countByValue = secondPropertyValues.reduce((acc, value) => {
    acc[value] = (acc[value] || 0) + 1;
    return acc;
  }, {});
  const keysWithMatchingCount = Object.keys(countByValue).filter(key => countByValue[key] === optionsCount);

  return (
    <div id="select-option" className="flex flex-col gap-2.5 max-md:pt-[var(--header-height)] max-md:-mt-[var(--header-height)]">
      {product.options?.map(({ id, name, values }, index) => {
        const isSecondOption = index === 1;

        return (
          <div key={id}>
            {name === 'Color' ? (
              <ProductColorOptionValues
                inventory={inventory}
                inventoryFetched={inventoryFetched}
                product={product}
                name={name}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                swatches={swatches}
                disableGroupHistory={disableGroupHistory}
                enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
                isSoldOut={isSoldOut}
                soldOutQty={soldOutQty}
                enabledGroupTabs={enabledGroupTabs}
                enabledGroupTabsLink={enabledGroupTabsLink}
                productTypeForGroupTabs={productTypeForGroupTabs}
                enabledGroupOptions={enabledGroupOptions}
                enabledGroupOptionsLink={enabledGroupOptionsLink}
                productTypeForGroupOptions={productTypeForGroupOptions}
                needsSelection={needsSelection}
                optionChanges={optionChanges}
                setOptionChanges={setOptionChanges}
                groupedBreadcrumbs={groupedBreadcrumbs}
              />
            ) : (
              <>
                <ProductOptionValues
                  enabledsizeGuide={enabledsizeGuide}
                  inventory={inventory}
                  inventoryFetched={inventoryFetched}
                  product={product}
                  name={name}
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                  values={values}
                  sizeGuides={sizeGuides}
                  isSoldOut={isSoldOut}
                  moreThanTwoOptions={moreThanTwoOptions}
                  isSecondOption={isSecondOption}
                  keysWithMatchingCount={keysWithMatchingCount}
                  needsSelection={needsSelection}
                  optionChanges={optionChanges}
                  setOptionChanges={setOptionChanges}
                />
              </>
            )}
          </div>
        );
      })}
      {enabledGroupOptions ? (
        <ProductGroupOptions
          product={product}
          // name={name}
          selectedOptions={selectedOptions}
          enabledGroupOptions={enabledGroupOptions}
          enabledGroupOptionsLink={enabledGroupOptionsLink}
          productTypeForGroupOptions={productTypeForGroupOptions}
          disableGroupHistory={disableGroupHistory}
          needsSelection={needsSelection}
          optionChanges={optionChanges}
          groupedBreadcrumbs={groupedBreadcrumbs}
        />
      ) : null}
    </div>
  );
}

ProductOptions.displayName = 'ProductOptions';
